// Unsaved editor changes, kept on this device until the server has them.
// A failed save, a sign-out, the Back button or a closed tab then never loses Jen's work.

interface Kept<T> {
  doc: T;
  base: string; // the server's updated_at the changes were made on
  at: number;
}

type Store = { getItem(k: string): string | null; setItem(k: string, v: string): void; removeItem(k: string): void };
const store = (): Store | undefined => (globalThis as { localStorage?: Store }).localStorage;
const key = (id: number) => `lavir-unsaved-${id}`;

export function keepDraft<T>(id: number, doc: T, base: string): void {
  try {
    store()?.setItem(key(id), JSON.stringify({ doc, base, at: Date.now() } satisfies Kept<T>));
  } catch {
    /* storage full or blocked: the normal save still runs */
  }
}

export function readDraft<T>(id: number): Kept<T> | null {
  try {
    const v = store()?.getItem(key(id));
    return v ? (JSON.parse(v) as Kept<T>) : null;
  } catch {
    return null;
  }
}

export function dropDraft(id: number): void {
  try {
    store()?.removeItem(key(id));
  } catch {
    /* nothing to do */
  }
}

/**
 * What to do with kept changes when the email opens.
 * restore: made on the version the server still has, so put them back without asking.
 * ask: the email changed somewhere else since, so let Jen choose.
 * drop: nothing kept, or it matches what the server has.
 */
export function draftAction<T>(kept: Kept<T> | null, server: { doc: T; updated_at: string }): 'restore' | 'ask' | 'drop' {
  if (!kept) return 'drop';
  if (JSON.stringify(kept.doc) === JSON.stringify(server.doc)) return 'drop';
  return kept.base === server.updated_at ? 'restore' : 'ask';
}
